import { render, staticRenderFns } from "./dibu.vue?vue&type=template&id=3626b92a&"
import script from "./dibu.vue?vue&type=script&lang=js&"
export * from "./dibu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports